import topbar from 'topbar';

const Topbar = () => {
  const $document = $(document);
  const topbarConfig = {
    barThickness: 3,
    barColors: {
      '1.0': '#e04403',
    },
    shadowBlur: 5,
    shadowColor: '#000000',
  };

  /**
   * Exibir loader
   */
  const show = () => {
    $document.trigger('ajaxStart');
  };

  /**
   * Esconder loader
   */
  const hide = () => {
    $document.trigger('ajaxStop');
  };

  /**
   * Adiciona configuração de apresentação de barra de carregamento / loader
   */
  const setup = () => {
    topbar.config(topbarConfig);
    $document.ajaxStop(topbar.hide);
    $document.ajaxStart(topbar.show);
    $document.on('hideLoader', topbar.hide);
    $document.on('showLoader', topbar.show);
  };

  setup();

  return {
    show,
    hide,
  };
};

const loader = {
  getHtmlLoader: (type) => {
    const defaultLoder = `<div class="w-100 text-center rnk-loader"><div class="spinner-border text-warning" role="status"><span class="sr-only">Aguarde...</span></div></div>`;
    switch (type) {
      default:
        return defaultLoder;
    }
  },
  topbar: Topbar(),
};

window.storeTheme = window.storeTheme || ({} as StoreTheme);

Object.assign(window.storeTheme, { helpers: Object.assign(window.storeTheme.helpers || {}, { loader }) });

export default {};
